import { render } from "./EmailTextSelect.vue?vue&type=template&id=c7288476&scoped=true"
import script from "./EmailTextSelect.vue?vue&type=script&lang=js"
export * from "./EmailTextSelect.vue?vue&type=script&lang=js"

import "./EmailTextSelect.vue?vue&type=style&index=0&id=c7288476&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7288476"]])

export default __exports__